module.exports = __webpack_public_path__ + "img/two.0f8643ff.jpg";